import { useRuntimeConfig } from "#imports";
export function getEndpoint(operation, operationName) {
  const config = useRuntimeConfig();
  return `${config?.public?.["nuxt-graphql-middleware"]?.serverApiPrefix}/${operation}/${operationName}`;
}
